import React from "react";
import StorePendingPayments from "../../components/Store/StorePendingPayments";

export default function StorePendingPaymentsPage() {
  return <StorePendingPayments />;
}